import BuyerApi from './buyer-api';
import { BuyerProjectInteractionTracking, _t } from '@bark/bark-core';
import moment from 'moment';

export default function () {
	const { Handlebars } = window;
	const buyerApi = BuyerApi();
	const experimentTracking = BuyerProjectInteractionTracking();

	const state = {
		projectIdHash: '',
		projectCreated: '',
		currentValue: '0',
	};

	const domElements = {
		responsePreferenceEditModalId: 'response-preference-edit-modal',
		responsePreferenceInfoModalId: 'response-preference-info-modal',
		responsePreferenceContainerId: 'response-preference-container',
		responsePreferenceMobileContainerId: 'response-preference-mobile-container',
		responsePreferenceTopContainerId: 'response-preference-top-container',
		responsePreferenceEditModalContainerId: 'response-preference-edit-modal-container',
		responsePreferenceInfoModalContainerId: 'response-preference-info-modal-container',
	};

	const hbTemplates = {
		responsePreference: Handlebars.compile(
			document.getElementById('response-preference-template').innerHTML,
		),
		responsePreferenceMobile: Handlebars.compile(
			document.getElementById('response-preference-mobile-template').innerHTML,
		),
		responsePreferenceTop: Handlebars.compile(
			document.getElementById('response-preference-top-template').innerHTML,
		),
		responsePreferenceEditModal: Handlebars.compile(
			document.getElementById('response-preference-edit-modal-template').innerHTML,
		),
		responsePreferenceInfoModal: Handlebars.compile(
			document.getElementById('response-preference-info-modal-template').innerHTML,
		),
	};

	const init = (projectIdHash, projectCreatedAt) => {
		window.useNamespace(['buyer_response-preference']).then(function () {
			if (projectIdHash && projectCreatedAt) {
				state.projectIdHash = projectIdHash;
				state.projectCreated = projectCreatedAt;

				buyerApi
					.getResponsePreference({
						projectIdHash: state.projectIdHash,
					})
					.then((result) => {
						if (result?.data?.value) {
							state.currentValue = result.data.value;
						}

						drawAll();
					});
			}
		});
	};

	const updateResponsePreference = (value) => {
		if (value) {
			$(`#${domElements.responsePreferenceEditModalId} .spinner-border`).removeClass(
				'd-none',
			);
			buyerApi
				.updateResponsePreference({
					projectIdHash: state.projectIdHash,
					value,
				})
				.then((result) => {
					if (result?.data?.value) {
						state.currentValue = result.data.value;
					}

					drawAll();

					$(`#${domElements.responsePreferenceEditModalId} .spinner-border`).addClass(
						'd-none',
					);
					$(`#${domElements.responsePreferenceEditModalId}`).modal('hide');
				})
				.catch(() => {
					$(`#${domElements.responsePreferenceEditModalId} .spinner-border`).addClass(
						'd-none',
					);
					$(`#${domElements.responsePreferenceEditModalId}`).modal('hide');
				});
		}
	};

	const drawAll = () => {
		drawResponsePreference();
		drawResponsePreferenceEditModal();
		drawResponsePreferenceInfoModal();
		bindListeners();
	};

	const drawResponsePreference = () => {
		$(`#${domElements.responsePreferenceContainerId}`).empty();
		$(`#${domElements.responsePreferenceMobileContainerId}`).empty();
		$(`#${domElements.responsePreferenceTopContainerId}`).empty();

		if (!projectCreatedMinutesAgo(5)) {
			let html = hbTemplates.responsePreference({
				allMatchesCanRespond: allMatchesCanRespond(),
				allMatchesCanRespondText: _t(
					'buyer_response-preference:widget.all-matches-text',
					{
						'all-matches-emphasised': `<span class="font-weight-medium"> ${_t(
							'buyer_response-preference:widget.all-matches-emphasised',
						)} </span>`,
					},
				),
				contactedMatchesCanRespondText: _t(
					'buyer_response-preference:widget.contacted-matches-text',
					{
						'contacted-matches-emphasised': `<span class="font-weight-medium"> ${_t(
							'buyer_response-preference:widget.contacted-matches-emphasised',
						)} </span>`,
					},
				),
			});
			$(`#${domElements.responsePreferenceContainerId}`).append(html);

			let mobileHtml = hbTemplates.responsePreferenceMobile({
				allMatchesCanRespond: allMatchesCanRespond(),
				allMatchesCanRespondText: _t(
					'buyer_response-preference:widget.all-matches-text',
					{
						'all-matches-emphasised': `<span class="color-green font-weight-medium"> ${_t(
							'buyer_response-preference:widget.all-matches-emphasised',
						)} </span>`,
					},
				),
				contactedMatchesCanRespondText: _t(
					'buyer_response-preference:widget.contacted-matches-text',
					{
						'contacted-matches-emphasised': `<span class="font-weight-medium"> ${_t(
							'buyer_response-preference:widget.contacted-matches-emphasised',
						)} </span>`,
					},
				),
			});
			$(`#${domElements.responsePreferenceMobileContainerId}`).append(mobileHtml);
		} else {
			let html = hbTemplates.responsePreferenceTop({
				allMatchesCanRespond: allMatchesCanRespond(),
			});
			$(`#${domElements.responsePreferenceTopContainerId}`).append(html);
		}
	};

	const drawResponsePreferenceEditModal = () => {
		let html = hbTemplates.responsePreferenceEditModal({
			allMatchesCanRespond: allMatchesCanRespond(),
		});

		$(`#${domElements.responsePreferenceEditModalContainerId}`).empty().append(html);
	};

	const drawResponsePreferenceInfoModal = () => {
		let html = hbTemplates.responsePreferenceInfoModal({
			closeProjectLink: `/buyers/close-project/${state.projectIdHash}/`,
		});

		$(`#${domElements.responsePreferenceInfoModalContainerId}`).empty().append(html);
	};

	const projectCreatedMinutesAgo = (minutes) => {
		//return false;
		let currentTime = moment.utc();
		let createdAt = moment.utc(state.projectCreated, 'YYYY-MM-DD HH:mm:SS');
		return currentTime.diff(createdAt, 'm') >= minutes;
	};

	const allMatchesCanRespond = () => {
		return state.currentValue === '0';
	};

	const bindListeners = () => {
		$('.js-response-preference-info-btn')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				$(`#${domElements.responsePreferenceInfoModalId}`).modal('show');
				experimentTracking.submitExpActWithVal(
					'Buyer Project Response Preferences - clicked tooltip',
				);
			});

		$('.js-response-preference-edit-btn')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				$(`#${domElements.responsePreferenceEditModalId}`).modal('show');
				experimentTracking.submitExpActWithVal(
					'Buyer Project Response Preferences - clicked edit',
				);
			});

		$('.js-response-preference-update-btn')
			.off('click')
			.on('click', function (e) {
				e.preventDefault();
				let value = $(
					`#${domElements.responsePreferenceEditModalId} input[type=radio][name='radio_resp_pref']:checked`,
				).val();
				updateResponsePreference(value);
				experimentTracking.submitExpActWithVal(
					'Buyer Project Response Preferences - clicked update request',
				);
			});

		$(
			`#${domElements.responsePreferenceEditModalId} input[type=radio][name=radio_resp_pref]`,
		)
			.off('change')
			.on('change', function (e) {
				let selectedValue = $(
					`#${domElements.responsePreferenceEditModalId} input[type=radio][name=radio_resp_pref]:checked`,
				).val();

				if (selectedValue == '1') {
					experimentTracking.submitExpActWithVal(
						'Buyer Project Response Preferences - only matches I contact',
					);
				}
			});

		$('.js-response-preference-cancel-btn').on('click', function (e) {
			experimentTracking.submitExpActWithVal(
				'Buyer Project Response Preferences - clicked cancel',
			);
		});

		$('.js-response-preference-close-btn').on('click', function (e) {
			experimentTracking.submitExpActWithVal(
				'Buyer Project Response Preferences - clicked closed',
			);
		});
	};

	return {
		init,
	};
}
